import { ScrollAnchorDirective } from './scroll-anchor.directive';
import { ScrollManagerDirective } from './scroll-manager.directive';
import { ScrollSectionDirective } from './scroll-section.directive';

export const CUSTOM_DIRECTIVES = [ScrollAnchorDirective, ScrollManagerDirective, ScrollSectionDirective];

export * from './scroll-manager.directive';
export * from './scroll-section.directive';
export * from './scroll-anchor.directive';
